import React, { useState, useEffect } from "react";

import Layout from "../../reusables/layout/layout";
import Requisition from "../../Component/requisitionforms/requisition_bece_cas";
import Tab from "../../Component/tab";
import { useSelector } from "react-redux";
import Spinner from "../../Component/ui/Spinner";

// const CustomTextField = styled(TextField)({
//   "& .MuiInputBase-input.Mui-disabled": {
//     color: "rgba(0,0,0,0.6) !important",
//     "-webkit-text-fill-color": "rgba(0,0,0,0.6) !important",
//     borderColor: "rgba(0,0,0,0.6) !important",
//   },
// });

const Bece = () => {

    const user = useSelector((state) => state.user.data.details);
    const token = useSelector((state) => state?.user?.data?.token);



    return (
        <div>
            <Layout>

                {token &&
                    <Requisition examName={'BECE'} examType='BECE Examination' />
                }
            </Layout>
        </div>
    )

}

export default Bece;